import { ReportSummaryCard } from "./ReportSummaryCard";
import { FlatList } from "react-native";
import { ReportModel } from "../../../services/api/types/reports/models/ReportModel";

export interface Props {
  reports: ReportModel[];
  newReportIds?: number[];
}

export function ReportSummaryList({ reports, newReportIds }: Props) {
  return (
    <FlatList
      contentContainerClassName="gap-2"
      data={reports ?? []}
      keyExtractor={(item) => `${item.id}`}
      renderItem={({ item }) => (
        <ReportSummaryCard report={item} newReportIds={newReportIds} />
      )}
    />
  );
}
